<template>
   <div class="table">
      <Delete :delete_message="delete_message" :show="show_delete_modal" @close="$store.commit('show_delete_modal',false)" @delete="deleteEvent()"/>

      <Modal :show="show_create_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_create_modal',false)">
         <template slot="title">
            <div class="title">{{TableModel.forms.addEvent.title}}</div>
            <div class="subtitle">{{TableModel.forms.addEvent.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="TableModel.forms.addEvent.name" 
                  :forms="TableModel.forms.addEvent.forms" 
                  :form_data="TableModel.forms.addEvent.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="addEvent({ref: $refs[TableModel.forms.addEvent.name]})" :disabled="loading">
                     Create <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Modal :show="show_delete_confirmation" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_delete_confirmation',false)">
         <template slot="title">
            <div class="title">{{TableModel.forms.delete_table.title}}</div>
            <div class="subtitle" v-html="TableModel.forms.delete_table.subtitle"></div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="TableModel.forms.delete_table.name" 
                  :forms="TableModel.forms.delete_table.forms" 
                  :form_data="TableModel.forms.delete_table.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-danger btn-r" @click="deleteEvent({ref: $refs[TableModel.forms.delete_table.name]})" :disabled="loading">
                     <i class="fa fa-trash"></i> Delete <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Modal :show="show_edit_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">{{TableModel.forms.editTable.title}}</div>
            <div class="subtitle">{{TableModel.forms.editTable.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="TableModel.forms.editTable.name" 
                  :forms="TableModel.forms.editTable.forms" 
                  :form_data="TableModel.forms.editTable.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="updateTable({ref: $refs[TableModel.forms.editTable.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <div class="top-actions clearfix">
         <div class="btn btn-primary btn-r" @click="$store.commit('show_create_modal',true)">
            Add Event <i class="fa fa-plus"></i>
         </div>
      </div>

      <Table v-bind="TableModel.tables.table.props" :data="tables" @on-action="handleActions">
         <template slot-scope="{ row }" slot="data_pull">
            <strong class="tx-small">{{ moment(row.last_data_pull).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="accessibility">
            <span class="tx-success bold" v-if="row.is_accessible">Accessible</span>
            <span class="tx-warning bold" v-else>Not Accessible</span>
         </template>
         <template slot-scope="{ row }" slot="unique_field">
            <span v-if="row.configs && row.configs.unique_field">{{row.configs.unique_field}}</span>
            <span v-else>N/A</span>
         </template>
      </Table>
   </div>
</template>

<script>
import table from "./table.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('table')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('table',table,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   data (){
      return {
         moment,
      };
   },
   computed: {
      ...mapGetters([
         'TableModel',
         'tables',
         'show_create_modal',
         'show_delete_confirmation',
         'show_edit_modal',
         'show_delete_modal',
         'loading',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'updateTable',
         'addEvent',
         'deleteEvent',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('table',table,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .table{
      .filter-data{
         background: $nav-top-color;
         margin: -10px -15px 30px -15px;
      }
      .tx-small{
         font-size: 12px;
      }
   }
</style>